import { queryOptions } from "@tanstack/react-query";
import { fetchOccPageData } from "./pageDataClient";
import { pageDataKeys } from "./pageDataKeys";
import type { PageInitialDataResult } from "./pageInitialDataTypes";
import type { QuoteSearchPageInitialData } from "./quoteSearchPageInitialData";

export const QUOTE_SEARCH_PAGE_ID = "quotes";

export const quoteSearchPageQueryOptions = () =>
  queryOptions({
    queryKey: pageDataKeys.page(QUOTE_SEARCH_PAGE_ID),
    queryFn: () =>
      fetchOccPageData<PageInitialDataResult<QuoteSearchPageInitialData>>("/page-data/my-account/quotes/search"),
    staleTime: 0,
    gcTime: 0,
    refetchOnWindowFocus: false,
    retry: 1,
  });
